import { CreateRoomPage } from './pages/CreateRoomPage';
import { RoomPage } from './pages/RoomPage';
import { JoinRoomPage } from './pages/JoinRoomPage';
import { getRoomIdFromPath } from './hooks/useRoomSecret';

// App routes based on URL path:
// /r/{roomId} -> RoomPage
// /join -> JoinRoomPage (short code pairing)
// everything else -> CreateRoomPage
//
// Error states (expired room, missing fragment) are handled inline
// by each page component.
export function App() {
  const path = window.location.pathname;
  const roomId = getRoomIdFromPath();
  if (roomId) {
    return <RoomPage roomId={roomId} />;
  }
  if (path === '/join') {
    return <JoinRoomPage />;
  }
  return <CreateRoomPage />;
}
